import { Button } from '@mui/material';

interface IButtonSignUp {
  loading: boolean;
  onClick: () => void;
}
export const ButtonSignUp: React.FC<IButtonSignUp> = (params) => {
  const { onClick, loading } = params;
  return (
    <>
      {loading ? (
        <Button size="large" variant="contained">
          Registrando, aguarde...
        </Button>
      ) : (
        <Button size="large" variant="contained" onClick={onClick}>
          Inscrever-se
        </Button>
      )}
    </>
  );
};
